module.exports = __webpack_public_path__ + "img/funnel.a8a916e5.svg";